import { TransferSetState, TransferState } from '@features/transfers/enums';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { pulse } from '@src/css/keyframes';

export function StatusDot({
  transferState,
}: {
  transferState: TransferState | TransferSetState;
}) {
  const theme = useTheme();

  const green = theme.palette.primary.main;
  const yellow = theme.palette.warning.light;
  const red = theme.palette.error.main;

  const colorMap: Record<TransferState | TransferSetState, string> = {
    [TransferState.COMPLETED]: green,
    [TransferState.FAILED]: red,
    [TransferState.PENDING]: yellow,
    [TransferState.IN_PROGRESS]: yellow,
    [TransferState.CANCELED]: yellow,
    [TransferSetState.TRANSFERRING_TO_CHECKING]: yellow,
    [TransferSetState.TRANSFERRING_TO_SAVINGS]: yellow,
    [TransferSetState.FINALIZED]: green,
    [TransferSetState.TRANSFERRING]: yellow,
  };

  return (
    <Box
      sx={{
        borderRadius: '50%',
        background: colorMap[transferState],
        margin: '0.5rem',
        height: '0.5rem',
        width: '0.5rem',
        boxShadow: `0 0 0 0 ${colorMap[transferState]}`,
        animation: `${pulse(colorMap[transferState])} 2s infinite`,
      }}
    />
  );
}
